var _g, _g2, _g3, _g4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1221,
    height: 1080,
    viewBox: "0 0 1221 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_34_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M944.5 609C944.5 710.068 865.569 792 768.204 792C670.838 792 605 710.068 605 609C605 507.932 670.838 426 768.204 426C865.569 426 944.5 507.932 944.5 609Z",
    fill: "#F05CDC"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_34_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M597 452C597 550.859 516.378 631 416.926 631C317.474 631 311 550.859 311 452C311 353.141 317.474 273 416.926 273C516.378 273 597 353.141 597 452Z",
    fill: "#6C0B87"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_34_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M739 588C739 668.634 673.319 734 592.296 734C511.274 734 506 668.634 506 588C506 507.366 511.274 442 592.296 442C673.319 442 739 507.366 739 588Z",
    fill: "#FC88CE"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_34_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M604 619C604 732.218 511.82 824 398.111 824C284.402 824 277 732.218 277 619C277 505.782 284.402 414 398.111 414C511.82 414 604 505.782 604 619Z",
    fill: "#B14BDB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_34_37",
    x: 328.6,
    y: 149.6,
    width: 892.3,
    height: 918.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_34_37"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_34_37",
    x: 34.6,
    y: -3.39999,
    width: 838.8,
    height: 910.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_34_37"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_34_37",
    x: 229.6,
    y: 165.6,
    width: 785.8,
    height: 844.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_34_37"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_34_37",
    x: 0.600006,
    y: 137.6,
    width: 879.8,
    height: 962.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.2,
    result: "effect1_foregroundBlur_34_37"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForm);
export default __webpack_public_path__ + "static/media/form.06db1717523d0e47cd98f4533101a426.svg";
export { ForwardRef as ReactComponent };